import React from "react";
import { Link } from "react-router-dom";
import mx from "@/i18n/mx.json";
import { CheckCircle2, ArrowLeft, Mail } from "lucide-react";

// Thank you page is ALWAYS in Spanish (mx). Route: /thank_you
const ThankYou = () => {
  const t = mx.thank_you;

  return (
    <main className="bg-[#F8FAFC] min-h-[70vh] py-16 lg:py-24" data-testid="thank-you-page">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white rounded-lg border border-slate-200 p-8 sm:p-12 text-center" data-testid="thank-you-message">
          <span className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-[#134E4A] mx-auto">
            <CheckCircle2 className="w-8 h-8 text-white" />
          </span>
          <span className="mt-6 inline-block px-3 py-1 rounded-full bg-[#134E4A]/10 text-[#134E4A] text-xs font-semibold tracking-wide uppercase">
            {t.eyebrow}
          </span>
          <h1 className="mt-4 font-serif text-3xl sm:text-4xl font-bold text-[#0B2545]">{t.title}</h1>
          <p className="mt-4 text-base text-[#475569] leading-relaxed">{t.body}</p>

          <div className="mt-8 text-left bg-[#F8FAFC] rounded-md border border-slate-200 p-6">
            <h2 className="font-serif text-lg font-semibold text-[#0B2545]">{t.next_title}</h2>
            <ul className="mt-3 space-y-2 text-[#0F172A]">
              {t.next_items.map((it, idx) => (
                <li key={idx} className="flex gap-2 items-start">
                  <CheckCircle2 className="w-4 h-4 mt-1 shrink-0 text-[#134E4A]" />
                  <span>{it}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-[#0B2545] text-white text-sm font-semibold hover:bg-[#0a1f3a]"
              data-testid="back-home-button"
            >
              <ArrowLeft className="w-4 h-4" />
              {t.back_home}
            </Link>
            <a
              href="mailto:atencion@fundelarento.com"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-md border-2 border-[#0B2545] text-[#0B2545] text-sm font-semibold hover:bg-[#0B2545] hover:text-white"
              data-testid="thank-you-email"
            >
              <Mail className="w-4 h-4" />
              atencion@fundelarento.com
            </a>
          </div>

          <p className="mt-6 text-xs text-[#475569]">{t.contact_line}</p>
        </div>
      </div>
    </main>
  );
};

export default ThankYou;
